import React, { JSX, useState, useEffect, useContext } from 'react';

import { LiveReserveContext } from '../../../../LiveLessonReseveContext';
import LiveReserveDateModalTime from './time/LiveReserveDateModalTime';

import { formatDate } from '../../../../../../../../util/utility';


function LiveReserveDateModalDate(props: any) {

  const {
    lsnMin, lessonTermMinute,
    // 30分2チケット：アンケートで１チケットプレゼントキャンペーン
    lsnSvyAddTicketStart, lsnSvyAddTicketEnd
  } = useContext(LiveReserveContext);

  const dateKey = props.dateKey;
  const dateInfo = props.dateInfo;

  const openDateKey = props.openDateKey;
  const setOpenDateKey = props.setOpenDateKey;
  const dateRef = props.dateRef;

  const chgOpenDate = () => {
    if(openDateKey == dateKey) {
      // 開いている場合→閉じる
      setOpenDateKey('');
    } else {
      // 閉じている場合→開く
      setOpenDateKey(dateKey);
    }
  }


  // 日付表示
  function getDispDateElement(stringDate: string): JSX.Element {
    const now = new Date();
    const dispDate = new Date(stringDate);
    const baseDate = formatDate(stringDate);
    // 一般の日付表示
    const elements: (string | JSX.Element)[] = [baseDate];

    // 30分2チケット：アンケートで１チケットプレゼントキャンペーン
    if(
      lsnMin == lessonTermMinute*2 && //30分選択
      now >= lsnSvyAddTicketStart && //現在：キャンペーン期間内
      now < lsnSvyAddTicketEnd && //現在：キャンペーン期間内
      dispDate >= lsnSvyAddTicketStart && //表示日付：キャンペーン期間内
      dispDate < lsnSvyAddTicketEnd //表示日付：キャンペーン期間内
    ) {
      elements.push(
        <span
          key="bonus"
          className='label label-danger'
          style={{ color: 'white', marginLeft: '10px' }}
        >キャンペーン中</span>
      );
    }

    return <>{elements}</>;
  }


  return (
    <div ref={dateRef} key={dateKey}>
      <div
        className="list-group-item list-group-item-warning"
        style={{ cursor: 'pointer' }}
        onClick={chgOpenDate}
      >
        <strong>{getDispDateElement(dateKey)}</strong>
        <span className="glyphicon glyphicon-chevron-down pull-right"></span>
      </div>

      {openDateKey == dateKey &&
        <div id={`c_${dateKey}`} className="sublinks">
          <ul className="list-group" style={{ marginBottom: '2px' }}>
            {Object.entries(dateInfo).map(([timeKey, timeInfo]: [string, any]) =>
              timeInfo && (
                <>
                  {/* 時間一覧 */}
                  <LiveReserveDateModalTime
                    dateKey={dateKey}
                    timeKey={timeKey}
                    timeInfo={timeInfo}
                  />
                </>
              )
            )}
          </ul>
        </div>
      }
    </div>
  );
}
  
export default LiveReserveDateModalDate;